import type { EditorPlugin } from './../../ricos-types';
import { createShortcut } from './../../ricos-types';

import { hardBreak } from './extension';

export const pluginHardBreak: EditorPlugin = {
  type: 'HARD_BREAK',
  config: {},
  tiptapExtensions: [hardBreak],
  shortcuts: [
    createShortcut({
      name: 'SoftNewLineMeta',
      description: 'ShortcutsSheet_Formatting_SoftNewLine',
      keys: { macOs: 'Meta+Enter', windows: 'Ctrl+Enter' },
      command({ publicCommands }) {
        publicCommands.softNewLine();
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
    createShortcut({
      name: 'SoftNewLineShift',
      description: 'ShortcutsSheet_Formatting_SoftNewLine',
      keys: { macOs: 'Shift+Enter', windows: 'Shift+Enter' },
      command({ publicCommands }) {
        publicCommands.softNewLine();
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],
};
